import { render, staticRenderFns } from "./personAccount.vue?vue&type=template&id=35648209&scoped=true&lang=pug"
import script from "./personAccount.vue?vue&type=script&lang=js"
export * from "./personAccount.vue?vue&type=script&lang=js"
import style0 from "./personAccount.vue?vue&type=style&index=0&id=35648209&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35648209",
  null
  
)

export default component.exports